import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin } from 'rxjs';
import { finalize, map, startWith, tap } from 'rxjs/operators';
import { NgFor, AsyncPipe } from '@angular/common'
import { DadosParentescoServiceAba9 } from "../../service/dados-parentesco-aba9/dados-parentesco-aba9.service";
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export interface ServidoresParentesco {
  nomeServidor: string;
  grauParentesco: string;
  acoes: string;
}

const ELEMENT_DATA: ServidoresParentesco[] = [
  { nomeServidor: 'Pedro da Silva Santos', grauParentesco: 'Irmão(ã)', acoes: '' },
  { nomeServidor: 'João da Silva Santos', grauParentesco: 'Irmão(ã)', acoes: '' },

];

@Component({
  selector: 'app-recadastramento-aba9',
  templateUrl: './recadastramento-aba9.component.html',
  styleUrls: ['./recadastramento-aba9.component.sass']
})
export class RecadastramentoAba9Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  form: FormGroup;
  user: DadosPessoaisAba1Response = null;

  nomeServidor: string;
  grauParentesco: string;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;
  isLoadingSpinner: boolean = true

  opcoes: string[] = ['Não', 'Sim'];
  displayedColumns: string[] = ['nomeServidor', 'grauParentesco', 'acoes'];
  dataSource = ELEMENT_DATA;

  myControl = new FormControl('');
  optionsServidor: string[] = ['Pedro da Silva Santos', 'João da Silva Santos', 'Antonio Soares'];
  //filteredOptions: Observable<string[]>;

  myControl2 = new FormControl('');
  optionsGrau: string[] = ['Irmão(ã)', 'Sogro(a)', 'Primo(a)'];
  filteredOptions2: Observable<string[]>;
  listaGrauParentesco: any[];

  selectedServer: any;
  opcaoSelecionada: string;
  possuiParentesco: string;
  temParentesco: boolean = false;
  matricula: number;
  codgGrauParentesco: number;

  public servidorDigitado: string;
  public options: any[] = [];
  public filteredOptions: any[] = [];

  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private dadosParentescoServiceAba9: DadosParentescoServiceAba9,
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));

    this.form = this.formBuilder.group({
      matricula: ['', Validators.required], // Campo obrigatório
      codgGrauParentesco: ['', Validators.required] // Campo obrigatório
    });

  }

  ngOnInit(): void {
    this.processarParentesco()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  private processarParentesco(): void {

    this.isLoadingSpinner = true;
    const grauParentesco$: Observable<any> = this.getGrauParentesco();
    const dadosParentesco$: Observable<any> = this.getDadosParentesco();

    forkJoin([grauParentesco$, dadosParentesco$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([grauParentesco, dadosParentesco]) => {
          this.atualizarFormulario(grauParentesco, dadosParentesco);
        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }

  public onInputChange(value: string): void {
    if (value) {
      this.servidorDigitado = value;
      this.getServidor(this.servidorDigitado).subscribe(
        (response) => {
          this.options = response.content;
          this.filteredOptions = this.options.filter((option) =>
            option.nome.toLowerCase().includes(value.toLowerCase())
          );
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.options = [];
      this.filteredOptions = [];
    }
  }
  public onOptionSelected(option: any): void {
    this.matricula = option.matricula;
  }

  public onOptionSelectedGrauParentesco(option: any): void {
    this.codgGrauParentesco = option.codigo
  }

  private getServidor(nomeServidor: string): Observable<any> {
    return this.dadosParentescoServiceAba9.getServidor(nomeServidor);
  }

  private getDadosParentesco(): Observable<any> {
    return this.dadosParentescoServiceAba9.getDadosParentesco();
  }

  private getGrauParentesco(): Observable<any> {
    return this.dadosParentescoServiceAba9.getListaParentesco();
  }

  atualizarFormulario(grauParentesco, dadosParentesco) {
    this.dataSource = dadosParentesco;
    this.listaGrauParentesco = grauParentesco

    if (dadosParentesco.length > 0) {
      this.temParentesco = true
      this.possuiParentesco = 'S'
    } else {
      this.possuiParentesco = 'N'
      this.temParentesco = false

    }
  }

  excluirParentesco(idRecadServParent: number, tipo: string): void {

    this.dadosParentescoServiceAba9.deletarParentesco(idRecadServParent).subscribe(
      (response) => {
        if (tipo != 'excluir-parentescos') {
          this.toasterService.success('Parentesco foi excluído com sucesso!');
        }
        this.processarParentesco()
      },
      (error) => {
        console.error(error);
      }
    );
  }

  checkParentesco() {
    const matriculaDesejada = this.matricula;
    const nomeServidorPorMatricula = this.form.get('matricula');
    if (nomeServidorPorMatricula.value != '') {
      if (matriculaDesejada == undefined) {
        this.toasterService.warning('Atenção: Selecione o servidor/magistrado no campo.');
      }else {
        const matriculaControl = this.form.get('matricula');
        const codGrauParentescoControl = this.form.get('codgGrauParentesco');      
        const matriculasCadastradas = this.dataSource.map(item => item['matricula']);
        const matriculaDesejada = this.matricula;

        if (matriculasCadastradas.includes(matriculaDesejada)) {
          this.toasterService.warning('Atenção: Parentesco com servidor ou magistrado já adicionado!');
          this.matricula = null
          matriculaControl.reset();
          codGrauParentescoControl.reset();
          return false;
        } else {
          return true;
        }
      }
    }
  }

  checkRadio() {
    const possuiParentesco = this.possuiParentesco;
    // Se a opção "N" for marcada e houver parentesco cadastrado
    if (possuiParentesco === 'N' && this.dataSource.length > 0) {
      // Loop para excluir todos os parentescos
      for (const parentesco of this.dataSource) {
        this.excluirParentesco(parentesco['idRecadServParent'], 'excluir-parentescos');
      }
      this.toasterService.success('Dados Atualizados com sucesso!');

    }
  }
  limparCampos() {
    this.filteredOptions = []; // Limpa a lista de options
    this.form.reset();
    this.form.get('matricula').setValidators(null);
    this.form.get('matricula').updateValueAndValidity();
    this.form.get('codgGrauParentesco').setValidators(null);
    this.form.get('codgGrauParentesco').updateValueAndValidity();
    
  }
  atualizarParentesco(requisicao) {
    if (requisicao == 'adicionar') {
      const body = {
        matricula: this.matricula,
        codgGrauParentesco: this.codgGrauParentesco
      };
      //Valida a obrigatoriedade do formulario
      if (this.form.valid) {
        if (this.checkParentesco()) {
          this.dadosParentescoServiceAba9.atualizarDadosParentesco(body).subscribe(
            (response) => {
              this.toasterService.success('Dados atualizados com sucesso');
              this.processarParentesco();
              this.limparCampos(); // Limpa os campos de input e seleção
            },
            (error) => {
              console.error('Erro ao atualizar os dados', error);
            }
          );
        }
      }
      else {
        this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
      }
    } else {
      this.checkRadio()
      this.avancaParaProximoTab()
    }
  }

  avancaParaProximoTab() {
    if (this.possuiParentesco == 'S' && this.temParentesco) {
      this.toasterService.success('Dados atualizados com sucesso');
      this.dadosSalvos.emit();
      this.formularioSalvo.emit();
    }
    if (this.possuiParentesco == 'S' && !this.temParentesco) {
      this.toasterService.warning('Informe o Nome e clique em Adicionar!');

    }
    if (this.possuiParentesco == 'N') {
      this.toasterService.success('Dados atualizados com sucesso');
      this.dadosSalvos.emit();
      this.formularioSalvo.emit();
    }

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
